import { Button, Card, CardActions, CardContent, CardMedia, Typography, } from "@mui/material";
import image_placeholder from "../../img/image_placeholder.svg";
import { Link } from "react-router-dom";

export default function ProjectCard(props) {
    const image = props.image ? props.image : image_placeholder;
    const title = props.title;
    const imageTitle = props.image ? title : "Web illustrations by Storyset";
    const description = props.description;
    const link = props.link;
    return (
        <Card sx={{ width: 300, display:'flex', justifyContent:'start', flexDirection:'column' }}>
            <CardMedia
                sx={{ height: 150, objectFit: "contain" }}
                image={image}
                title={imageTitle}
                component="img"
            />
            <CardContent>
                <Typography variant="h6" component="div" align="left" sx={{ ml: 1}} >{title}</Typography>
                <Typography variant="body1" color="text.secondary" align="left" sx={{ whiteSpace: 'pre-wrap', ml: 1, mr: 1, mt: 1}}>
                    {description}
                </Typography>
            </CardContent>
            {link ? 
            <CardActions sx={{ flex:'1', alignItems:'flex-end' }}>
                {link.map((element) => { 
                    return (
                        <Button size="small" sx={{ ml: 1 }} component={Link} to={element.link} >{ element.name }</Button>
                )})}
            </CardActions>
             :
            <></>}
        </Card>
    );
}